import clsx from 'clsx';
import React from 'react';

import OfferCards from '@components/pages/SubscribeTest/OfferSelection/OfferCards';
import OfferTable from '@components/pages/SubscribeTest/OfferSelection/OfferTable';
import { BENEFITS } from '@components/pages/SubscribeTest/OfferSelection/constants';
import { subscribe_one_path } from '@routes';
import type { SelectedOffer } from '@utils/backend-api/subscribe';

import { marginValues, paddingValues } from './constants';
import type { SubscribeMatrixBlockProps } from './interfaces';

const SubscribeMatrixBlock = ({ config, offers }: SubscribeMatrixBlockProps) => {
  const offersToDisplay = [
    config?.show_monthly && offers.monthly_offer,
    config?.show_annual && offers.annual_offer,
    config?.show_pro && offers.pro_offer,
  ];
  const filteredOffersToDisplay = offersToDisplay.filter(Boolean);

  const modifiedBenefits = BENEFITS.map((benefit) => ({
    ...benefit,
    eligibility: benefit.eligibility.reduce((acc, perk, index) => {
      // Eligibility is an array of booleans in order of Monthly, Annual, Pro
      if (offersToDisplay?.[index]) return [...acc, perk];
      return acc;
    }, []),
  }));

  const handleOfferClick = (plan: SelectedOffer) => {
    if (!plan?.code) return;

    const anchor = document.createElement('a');
    anchor.href = subscribe_one_path({ offer: plan?.code });
    anchor.click();
  };

  return (
    <div
      className={clsx(
        'subscribe-matrix-block my-0',
        config?.css_classes,
        marginValues[config?.margin],
        paddingValues[config?.padding]
      )}
    >
      <OfferTable
        benefits={modifiedBenefits}
        offers={filteredOffersToDisplay}
        onOfferClick={() => {}}
        setSelectedOffer={handleOfferClick}
      />
      <OfferCards
        monthlyOffer={offers.monthly_offer}
        onOfferClick={() => {}}
        setSelectedOffer={handleOfferClick}
        showGroup={config?.show_group}
        showYP={config?.show_yp}
        ypOffer={offers.yp_offer}
      />
    </div>
  );
};

export default SubscribeMatrixBlock;
